import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../utils/axiosInstance';
import { loginApi, getAuthHeaders } from '../config/api';

export const validateInvitation = createAsyncThunk(
  'invitation/validate',
  async ({ token }, { rejectWithValue }) => {
    try {
      const res = await axios.get(loginApi(`/invitation/validate/${token}`));
      return res.data;
    } catch {
      return rejectWithValue('Invalid or expired invitation');
    }
  },
);

export const sendInvitation = createAsyncThunk(
  'invitation/send',
  async ({ tenantId, email, role }, { rejectWithValue, getState }) => {
    try {
      const body = {
        ADMIN: role === 'admin' ? [email] : [],
        USER: role === 'user' ? [email] : [],
      };
      const res = await axios.post(loginApi(`/invitation/${tenantId}/invite`), body, {
        headers: getAuthHeaders(getState),
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to send invitation');
    }
  },
);

export const acceptInvitation = createAsyncThunk(
  'invitation/accept',
  async ({ token }, { rejectWithValue }) => {
    try {
      const res = await axios.post(loginApi(`/invitation/accept/${token}`));
      return res.data;
    } catch {
      return rejectWithValue('Failed to accept invitation');
    }
  },
);

const invitationSlice = createSlice({
  name: 'invitation',
  initialState: {
    sendLoading: false,
    sendError: null,
    sendSuccess: false,
    validateLoading: false,
    validateError: null,
    invitationData: null,
    acceptLoading: false,
    acceptError: null,
  },
  reducers: {
    resetSendInvitation(state) {
      state.sendLoading = false;
      state.sendError = null;
      state.sendSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendInvitation.pending, (state) => {
        state.sendLoading = true;
        state.sendError = null;
        state.sendSuccess = false;
      })
      .addCase(sendInvitation.fulfilled, (state) => {
        state.sendLoading = false;
        state.sendSuccess = true;
      })
      .addCase(sendInvitation.rejected, (state, action) => {
        state.sendLoading = false;
        state.sendError = action.payload;
      })
      .addCase(validateInvitation.pending, (state) => {
        state.validateLoading = true;
        state.validateError = null;
      })
      .addCase(validateInvitation.fulfilled, (state, action) => {
        state.validateLoading = false;
        state.invitationData = action.payload;
      })
      .addCase(validateInvitation.rejected, (state, action) => {
        state.validateLoading = false;
        state.validateError = action.payload;
      })
      .addCase(acceptInvitation.pending, (state) => {
        state.acceptLoading = true;
        state.acceptError = null;
      })
      .addCase(acceptInvitation.fulfilled, (state) => {
        state.acceptLoading = false;
      })
      .addCase(acceptInvitation.rejected, (state, action) => {
        state.acceptLoading = false;
        state.acceptError = action.payload;
      });
  },
});

export const { resetSendInvitation } = invitationSlice.actions;
export default invitationSlice.reducer;
